import amActionTypes from './am.constants';

export function amReducer(state = { isSideMenuOpen: false }, action) {
    switch (action.type) {
        case amActionTypes.TOGGLE_SIDE_MENU:
            return {
                ...state,
                isSideMenuOpen: !state.isSideMenuOpen,
            };
        case amActionTypes.CLOSE_SIDE_MENU:
            return {
                ...state,
                isSideMenuOpen: false,
            };
        default:
            return state;
    }
}
